import { gql } from "@apollo/client"

export const GET_HABITACIONES = gql`
    query Habitaciones($hotel_id: ID) {
        habitaciones(hotel_id: $hotel_id) {
            habitacion_id
            hotel_id
            tipo_habitacion_id
            numero_habitacion
            estado
            tipo_habitacion {
                tipo_habitacion_id
                nombre
            }
            colaborador_tareas_sin_finalizar {
                colaborador_tarea_id
            }
        }
    }
`
